import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'app-spinner-overlay',
    imports: [SpinnerComponent],
    templateUrl: './spinner-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './spinner-overlay.component.scss'
})
export class SpinnerOverlayComponent {
  @Input() public message!: string;

}
